import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges, isDevMode } from '@angular/core';

const TEST_ID_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*__[a-z0-9]+(?:-[a-z0-9]+)*--[a-z0-9]+(?:-[a-z0-9]+)*$/;

@Directive({
  selector: '[svcTestId]',
})
export class SvcTestIdDirective implements OnChanges {
  @Input() public svcTestId: string;

  /**
   * When false, the directive does not render `data-testid` on its host element.
   * A Design System form component that hosts this directive can set this to false
   * (via `@Self()` injection) to forward the test id to its inner control instead,
   * so automation targets the real `<input>`/interactive element and the id is not duplicated on the wrapper.
   */
  public useOnHost = true;

  public get normalizedTestId(): string {
    return (this.svcTestId ?? '').trim();
  }

  constructor(
    private readonly _elementRef: ElementRef<HTMLElement>,
    private readonly _renderer: Renderer2
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (!changes['svcTestId']) return;

    const normalizedValue = this.normalizedTestId;

    if (isDevMode() && normalizedValue && !TEST_ID_PATTERN.test(normalizedValue)) {
      console.warn(`[svcTestId] invalid test id format: "${normalizedValue}"`);
    }

    if (!this.useOnHost) return;

    if (!normalizedValue) {
      this._renderer.removeAttribute(this._elementRef.nativeElement, 'data-testid');
      return;
    }

    this._renderer.setAttribute(this._elementRef.nativeElement, 'data-testid', normalizedValue);
  }
}
